<template>
  <v-app light class="secondary">
    <v-content style="height: 100%; padding: 0px;">
      <MainToolbar v-bind:options="{}"></MainToolbar>
      <MarketSearchBar v-if="$route.path.includes('/market') || $route.path.includes('/search')" v-bind:options="{input: searchInput, category: category}"></MarketSearchBar>
      <router-view style="min-height: calc(100vh - 400px);"/>
      <Footer></Footer>
    </v-content>
    <notifier></notifier>
    <loading></loading>
  </v-app>
</template>

<style>
  @import url('https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700,800');
  body{
    color: #011E41;
  }
  #appHeader{
    width: 100%;
    height: 60px;
    align-items: center;
    display: flex;
    background: #011E41;
    padding-left: 16px;
  }
  .application{
    font-family: 'Open Sans' !important;
  }
  button{
    text-transform: capitalize !important;
    font-size: 18px !important
  }
  button:hover:before{
    background-color: transparent !important;
  }
  .theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat){
    background-color: #B2BBC5 !important;
    color: white !important;
  }
</style>

<script>
import Notifier from './components/Notifier'
import Loading from './components/Loading'
import axios from 'axios'
import { mapGetters, mapMutations } from 'vuex'
import MainToolbar from './components/appElements/MainToolbar.vue'
import Footer from './components/appElements/Footer.vue'
import MarketSearchBar from './components/appElements/MarketSearchBar.vue'

export default {
  data () {
    return {
      searchInput: '',
      category: 'All Categories'
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'currentUser'])
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    getOrganizationData: function () {
      axios.all([this.$store.dispatch('getOrganizationsWithAllByUserId', {id: this.currentUser.id})]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.$store.commit('setLoginState', 'closed')
          this.$store.commit('setOrganizations', response.data.payload)
        } else {
          this.notify({message: 'Something went wrong.', show: true})
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    getRoles: function () {
      axios.all([this.$store.dispatch('getRolesWithAll')]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.$store.commit('setRoles', response.data.payload)
        } else {
          this.notify({message: 'Something went wrong.', show: true})
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    getPlans: function () {
      axios.all([this.$store.dispatch('getPlans')]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.$store.commit('setPlans', response.data.payload)
        } else {
          this.notify({message: 'Something went wrong.', show: true})
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    }
  },
  components: {Notifier, Loading, MainToolbar, Footer, MarketSearchBar},
  watch: {
    isLoggedIn: function (newVal, oldVal) {
      if (newVal) {
        this.getOrganizationData()
      }
    },
    '$route.query': function (newVal, oldVal) {
      if (this.$route.query) {
        this.searchInput = this.$route.query.input
        this.category = this.$route.query.category
      }
    }
  },
  mounted () {
    this.getRoles()
    this.getPlans()
    if (this.isLoggedIn) {
      this.getOrganizationData()
    }
    if (this.$route.query) {
      this.searchInput = this.$route.query.input
      this.category = this.$route.query.category || this.$route.query.category === '' ? this.$route.query.category : 'All Categories'
    }
    window.scrollTo(0, 0)
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue